import Parse from 'parse'
const Entry = new Parse.Object.extend('Entry')

const state = {
  entries: [],
  entry: null
}

const mutations = {
  setEntries (state, entries) {
    state.entries = entries
  },

  setEntry (state, entry) {
    state.entry = entry
  }
}

const getters = {
  allowed: (state) => {
    return state.entry.get('allowed').get('name') === 'allowed'
  }
}

const actions = {
  async retrieveEntries ({ commit }) {
    let query = new Parse.Query('Entry')
    query.equalTo('user', Parse.User.current().id)
    query.include('event')
    commit('setEntries', await query.find())
  },

  async fetchEntry ({ commit }) {
    let query = new Parse.Query('Entry')
    query.equalTo('user', Parse.User.current().id)
    query.include('event')
    commit('setEntry', await query.first())
  },

  async saveEntry ({ rootState }) {
    let entry = new Entry()
    let event = rootState.event.selected
    entry.set('event', event)
    entry.set('user', Parse.User.current().id)
    entry.set('username', Parse.User.current().get('username'))

    // 自動承認のイベントだったら、参加状態を許可に
    if (event.get('autoEntry')) {
      let query = new Parse.Query('Option')
      query.equalTo('category', 'entry')
      query.equalTo('name', 'allowed')
      entry.set('allowed', await query.first())
    }

    await entry.save()
  },

  async cancel () {
    await Parse.Cloud.run('cancelEntry')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
